import dayjs from "dayjs"

export const LOCKED_SIZE = "__LOCKED__"
export const UNIT_FILL = "#f1f5f9"
export const STROKE = "#cad5e2"
export const LOCKED_FILL = "#fff"
export const LOCKED_STROKE = "#999"

export const RESOURCE_OVERUSE_META = [
  {
    key: "water",
    label: "수도 과사용"
  },
  {
    key: "hotwater",
    label: "온수 과사용"
  },
  {
    key: "elect",
    label: "전기 과사용"
  },
  {
    key: "gas",
    label: "가스 과사용"
  },
  {
    key: "hot",
    label: "난방 과사용"
  },
  {
    key: "leak",
    label: "누수 의심"
  }
]

const RESOURCE_MAP = {
  water: "water",
  hotwater: "hotwater",
  elect: "elect",
  gas: "gas",
  hot: "hot"
}

const LABEL_MAP = {
  water: "수도",
  hotwater: "온수",
  elect: "전기",
  gas: "가스",
  hot: "난방"
}

export const createAptMonitoringMap = (aptSizeMap, overuseUnits = [], leakUnits = []) => {
  const monitoringMap = Object.fromEntries(
    Object.entries(aptSizeMap).map(([dong, unitMap]) => [
      dong,
      Object.fromEntries(
        Object.entries(unitMap).map(([ho, size]) => [
          ho,
          {
            size,
            badges: []
          }
        ])
      )
    ])
  )

  const history = [
    ...overuseUnits.map((unit) => ({
      dong: String(Number(unit.dong)),
      ho: String(Number(unit.ho)),
      resource: RESOURCE_MAP[unit.resource],
      label: LABEL_MAP[unit.resource],
      value: unit.sum,
      occurredAt: dayjs().format("YYYY-MM-DD")
    })),

    ...leakUnits.map((unit) => ({
      dong: String(Number(unit.dong)),
      ho: String(Number(unit.ho)),
      resource: "leak",
      label: "누수",
      value: unit.leak_volume,
      occurredAt: unit.leak_start_at
    }))
  ]

  const summary = Object.fromEntries(
    Object.entries(aptSizeMap).map(([dong, unitMap]) => [
      dong,
      {
        totalHouseholds: Object.keys(unitMap).length,
        abnormalHouseholds: 0,
        abnormal: 0,
        water: 0,
        hotwater: 0,
        elect: 0,
        gas: 0,
        hot: 0,
        leak: 0
      }
    ])
  )

  overuseUnits.forEach((unit) => {
    const dong = String(Number(unit.dong))
    const ho = String(Number(unit.ho))

    const target = monitoringMap[dong]?.[ho]

    if (!target) return

    const resource = RESOURCE_MAP[unit.resource]

    if (!resource) return

    if (!target.badges.includes(resource)) {
      const wasNormal = target.badges.length === 0

      target.badges.push(resource)
      summary[dong][resource] += 1
      summary[dong].abnormal += 1

      if (wasNormal) {
        summary[dong].abnormalHouseholds += 1
      }
    }
  })

  leakUnits.forEach((unit) => {
    const dong = String(Number(unit.dong))
    const ho = String(Number(unit.ho))

    const target = monitoringMap[dong]?.[ho]

    if (!target) return

    if (!target.badges.includes("leak")) {
      const wasNormal = target.badges.length === 0

      target.badges.push("leak")
      summary[dong].leak += 1
      summary[dong].abnormal += 1

      if (wasNormal) {
        summary[dong].abnormalHouseholds += 1
      }
    }
  })

  return { monitoringMap, summary, history }
}
